import React from 'react';
export const defaultAccordionItemContext = {
    open: false,
    itemDisabled: false,
    toggleOpen: () => null,
};
export const AccordionItemContext = React.createContext(defaultAccordionItemContext);
//# sourceMappingURL=accordionItem.context.js.map